import React, { useEffect, useContext, useState } from "react";
import "../Styles.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import "../../../ui-styles/inlineLink/inlineLinkIcon.css";
import { LangCtx, RoleCtx } from "../../../lib/context";
import { clinicAppointmentReport, clinicUserReport } from "../../../actions/users";
import { PayLoadCtx } from "../../../lib/context";
import CardsList from "../../common/CardsList";
import LicenseExpiryPopup from "./licenseExpiryPopup";
import { Link, useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import Loading from "../../../components/loading";
import {API} from 'aws-amplify';

const ClinicDashboard = (props) => {
    const [uloading, setULoading] = useState(false);
    const history = useHistory();
    const { payload } = useContext(PayLoadCtx);
    const [aloading, setALoading] = useState(false);
    const [usersReports, setUsersReports] = useState({});
    const [apptReports, setApptReports] = useState({});
    const [openLicensePopup, setOpenLicensePopup] = useState({ open: false, days: 0 });
    const { role } = useContext(RoleCtx);
    const { l } = useContext(LangCtx);
    // window.Cookies = Cookies;

    const parsedUrl = new URL(window.location.href);
    // const parsedUrl = React.useMemo(() => new URL(window.location.href), []);





    // payload?.expiryAt = 2023/07/06 (05:29:59)
    // const refCookie = Cookies.get("isFree");
    // Cookies.set('isFree', true, { domain: parsedUrl.hostname, expires: 1, path: parsedUrl.pathname, secure: true, sameSite: 'Strict', httpOnly:false});

    //demo date for testing.....
    // const currExpireAt = new Date(2023, 5, 22).setHours(0, 0, 0, 0);



    useEffect(() => {
        if (payload !== null) {
            const expireDate = new Date(payload?.expiryAt).setHours(0, 0, 0, 0);
            const currExpireAt = new Date().setHours(0, 0, 0, 0);
            const difference = expireDate - currExpireAt;
            const differenceInDays = Math.floor(difference / (1000 * 3600 * 24));
            const cookieExists = Cookies.get('isFree');
            if (role === "C" && differenceInDays <= 0) {
                history.push(`/place-your-order/INVCCCP/${payload?.doctorsCount}`);
            } else if (role === "C" && differenceInDays <= 14 && payload?.isFree === undefined && !cookieExists) {
                setOpenLicensePopup({ open: true, days: differenceInDays });
                Cookies.set('isFree', true, { domain: parsedUrl.hostname, expires: 1, secure: true, sameSite: 'Strict', httpOnly: false  });
            } else if ((role === "D" || role === "P") && payload?.licenseStatus === false) {
                history.push("/no-license");
            }
        }
    }, [payload, role]);

    useEffect(() => {   
        setULoading(true);
        setALoading(true);
        if (role === "C") {
            clinicUserReport()
                .then((res) => {
                    setULoading(false);
                    if (res.status) {
                        setUsersReports({ ...res.data });
                    } else {
                        setUsersReports({});
                    }
                })
                .catch((err) => {
                    if(API.isCancel(err)) {
                        console.log("API is canceled................");
                    } else {
                        setULoading(false);
                    }
                    setUsersReports({});
                    console.log("err ==== ", err);
                });
            clinicAppointmentReport()
                .then((res) => {
                    setALoading(false);
                    if (res.status) {
                        setApptReports({ ...res.data });
                    } else {
                        setApptReports({});
                    }
                })
                .catch((err) => {
                    if(API.isCancel(err)) {
                        console.log("API is canceled................");
                    } else {
                        setALoading(false);
                    }
                    setApptReports({});
                    console.log("err ==== ", err);
                });
        }
    }, [role]);

    const handleClosePopup = () => {
        setOpenLicensePopup({ open: false, days: 0 });
    };
    return (
        <div className="baseContainer">
            <div className="hdngTopCol colBlock">
                <div className="hdngTopBox etcPdng">
                    <h2 className="topHdngTxt">{l.dashboard}</h2>
                </div>
                <div className="inlineItemContainer">
                    <div className="inlineItemGroup">
                        {/* <Link to="/clinic-createusers?pId" className="inlineLink Sm"><span>{l.create_pat}</span></Link> */}
                        <Link to="/clinic-users" className="inlineLink Sm">
                            <span>{l.book_apptmnt}</span>
                        </Link>
                    </div>
                </div>
            </div>
            {(uloading || aloading) && <Loading />}
            <CardsList usersCount={usersReports} apptCount={apptReports} role={role} />
            {openLicensePopup?.open && (
                <LicenseExpiryPopup openDelete={openLicensePopup?.open} closeCallback={handleClosePopup} days={openLicensePopup.days} />
            )}
        </div>
    );
};

export default ClinicDashboard;
